module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Title_Page"
  }, [_c('h2', {
    staticClass: "chaptitle3"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Contents#ch5",
      "id": "rch5"
    }
  }, [_c('b', [_vm._v("Rules of TV")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('b', [_vm._v("At some point in your life, you’ve no doubt been watching a television show and muttered, “That would never happen in real life.” And yet these things happen on the tube…a lot.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p22-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p22-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p23-1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p23-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p23-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p24-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p24-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('b', [_vm._v("COMMON Wii GAMING SYSTEM INJURIES: BLACK EYES, HAND INJURIES, AND TENNIS ELBOW.")])])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d5aabab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/012_Chapter5.vue
// module id = 93
// module chunks = 0